import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/ticket.styles'
import clsx from 'clsx'
import { useMediaQuery } from '@material-ui/core'
import leftArrow from './assets/images/leftArrow.svg'

const useStyles = makeStyles(styles)

export default function SwiperTicket({
    name,
    open,
    src,
    primaryText,
    index,
    secondaryText,
    bigContent,
    handleClick
}) {
    const props = { open }
    const isMobile = useMediaQuery('(max-width: 1230px)')
    const classes = useStyles(props)
    const onClick = e => {
        e.stopPropagation()
        handleClick(index)
    }
    return (
        <span className={clsx(classes.span, open && classes.boxShadow)} onClick={onClick} >
            <div className={clsx(classes.root, open && classes.expanded)} >
                <span className={classes.textWrap} >
                    <p className={classes.name} >{name}</p>
                </span>
                <img src={leftArrow} className={clsx(open && classes.showArrow, classes.arrow)} alt='left arrow' />
            </div>
            <p
                className={clsx(
                    classes.bigText,
                    open && classes.textOpened,
                    (open && !isMobile) && classes.desktopContent,
                    isMobile && classes.textOpened
                )}>
                {bigContent}
            </p>
        </span>
    )
}
